// Public dual-CTA band pointing customers at both journeys:
//  1. Order individual dishes (à-la-carte) → /products
//  2. Subscribe to a meal plan            → /meal-plans
import { Link } from "@tanstack/react-router";
import { ShoppingBag, CalendarClock } from "lucide-react";
import { Section } from "@/components/Section";
import { trackCtaClick } from "@/lib/analytics";

export function AlacarteComingSoon() {
  return (
    <Section className="py-10">
      <div className="grid gap-4 md:grid-cols-2">
        <div className="flex flex-col gap-4 rounded-2xl border border-border/70 bg-card p-6 md:p-8">
          <div className="flex items-start gap-3">
            <div className="mt-1 rounded-full bg-primary/10 p-2 text-primary">
              <ShoppingBag size={18} strokeWidth={1.75} aria-hidden />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
                Order individual dishes
              </div>
              <h3 className="mt-2 font-display text-2xl font-medium">À la carte</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                Pick single dishes for the delivery date you want — no subscription. Live availability, meal-slot cutoffs and pricing per neighbourhood.
              </p>
            </div>
          </div>
          <div>
            <Link
              to="/products"
              onClick={() =>
                trackCtaClick({ action: "order_alacarte", location: "home-dual-cta", href: "/products" })
              }
              className="inline-flex items-center rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            >
              Explore à la carte
            </Link>
          </div>
        </div>
        <div className="flex flex-col gap-4 rounded-2xl border border-border/70 bg-card p-6 md:p-8">
          <div className="flex items-start gap-3">
            <div className="mt-1 rounded-full bg-primary/10 p-2 text-primary">
              <CalendarClock size={18} strokeWidth={1.75} aria-hidden />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
                Weekly & monthly plans
              </div>
              <h3 className="mt-2 font-display text-2xl font-medium">Meal plans</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                Balanced Everyday, Low Carb and more — configured to your preferences, delivered on a fixed rhythm.
              </p>
            </div>
          </div>
          <div>
            <Link
              to="/meal-plans"
              onClick={() =>
                trackCtaClick({ action: "explore_meal_plans", location: "home-dual-cta", href: "/meal-plans" })
              }
              className="inline-flex items-center rounded-full border border-primary bg-background px-5 py-2.5 text-sm font-medium text-primary hover:bg-primary/5"
            >
              Explore meal plans
            </Link>
          </div>
        </div>
      </div>
    </Section>
  );
}